import React, { useState } from "react";

import { FaEye, FaEyeSlash } from "react-icons/fa";

import { motion } from "framer-motion";
import toast from "react-hot-toast";
import AuthLayout from "../../../shared/Layouts/AuthLayout";
import LinkHead from "../../../shared/components/LinkHead";
import { PAD_LOCK } from "../../../assets";
import ButtonV2 from "../../../shared/components/buttonV2";
import { profileUpdate } from "../../../Services/auth";

function ResetPassword() {
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    password: false,
    confirmPassword: false,
    // currentPassInput: "",
    passInput: "",
    confirmPassInput: "",
  });

  const passwordPattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]+$/; // accepted password inputs

  const [loading, setLoading] = useState(false);

  const handleResetPassword = async () => {
    setLoading(true);

    const payload = {
      // current_password: showPassword.currentPassInput,
      password: showPassword.passInput,
      password_confirmation: showPassword.confirmPassInput,
    };
    try {
      const response = await profileUpdate(payload);
      if (response) {
        toast.success(response?.message || "Password reset successfully");
        setShowPassword({
          // currentPassInput: "",
          currentPassword: false,
          password: false,
          confirmPassword: false,
          passInput: "",
          confirmPassInput: "",
        });
        window.history.replaceState({}, "", "/sign-in");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LinkHead
        title="Reset Password"
        content="Login to LexScript to perform seamless audio file editing and lots more."
      />

      <AuthLayout>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="lg:w-[30rem] w-full h-[400px] shadow-boxShadow rounded-lg lg:p-10 p-5 flex flex-col gap-y-6 items-start"
        >
          <div className="flex flex-col gap-y-2">
            <span className="text-2xl font-bold text-primary-300">
              Set New Password
            </span>
            <span className="text-primary-300 font-normal text-sm">
              Kindly create a new password below
            </span>
          </div>
          <form
            action=""
            onSubmit={(e) => e.preventDefault()}
            className="flex flex-col gap-y-4 w-full"
          >
            {/* <div className="flex flex-col items-start w-full gap-y-1">
              <span className="text-sm font-medium text-[#4F5762]">
                Current Password
              </span>
              <div className="w-full h-[48px] justify-between rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                <div className="flex items-center gap-x-2">
                  <img src={PAD_LOCK} className="w-[20px] h-[20px]" alt="" />

                  <input
                    type={showPassword.currentPassword ? "text" : "password"}
                    name="password"
                    value={showPassword.currentPassInput}
                    onChange={(e) =>
                      setShowPassword({
                        ...showPassword,
                        currentPassInput: e.target.value,
                      })
                    }
                    placeholder="******************"
                    className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
                  />
                </div>
                {showPassword.currentPassword ? (
                  <span
                    className="cursor-pointer "
                    onClick={() =>
                      setShowPassword({
                        ...showPassword,
                        currentPassword: false,
                      })
                    }
                  >
                    <FaEyeSlash color="#808080" />
                  </span>
                ) : (
                  <span
                    className="cursor-pointer"
                    onClick={() =>
                      setShowPassword({
                        ...showPassword,
                        currentPassword: true,
                      })
                    }
                  >
                    <FaEye color="#808080" />
                  </span>
                )}
              </div>
            </div> */}
            <div className="flex flex-col items-start w-full gap-y-1">
              <span className="text-sm font-medium text-[#4F5762]">
                New Password
              </span>
              <div className="w-full h-[48px] justify-between rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                <div className="flex items-center gap-x-2">
                  <img src={PAD_LOCK} className="w-[20px] h-[20px]" alt="" />

                  <input
                    type={showPassword.password ? "text" : "password"}
                    name="password"
                    value={showPassword.passInput}
                    onChange={(e) =>
                      setShowPassword({
                        ...showPassword,
                        passInput: e.target.value,
                      })
                    }
                    placeholder="******************"
                    className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
                  />
                </div>
                {showPassword.password ? (
                  <span
                    className="cursor-pointer "
                    onClick={() =>
                      setShowPassword({ ...showPassword, password: false })
                    }
                  >
                    <FaEyeSlash color="#808080" />
                  </span>
                ) : (
                  <span
                    className="cursor-pointer"
                    onClick={() =>
                      setShowPassword({ ...showPassword, password: true })
                    }
                  >
                    <FaEye color="#808080" />
                  </span>
                )}
              </div>
              {showPassword.passInput &&
                !passwordPattern.test(showPassword.passInput) && (
                  <span className="text-xs font-normal text-red-500">
                    Password must contain uppercase, lowercase, a number, and a
                    special character.
                  </span>
                )}
            </div>
            <div className="flex flex-col items-start w-full gap-y-1">
              <span className="text-sm font-medium text-[#4F5762]">
                Confirm Password
              </span>
              <div className="w-full h-[48px] justify-between rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                <div className="flex items-center gap-x-2">
                  <img src={PAD_LOCK} className="w-[20px] h-[20px]" alt="" />

                  <input
                    type={showPassword.confirmPassword ? "text" : "password"}
                    name="password"
                    value={showPassword.confirmPassInput}
                    onChange={(e) =>
                      setShowPassword({
                        ...showPassword,
                        confirmPassInput: e.target.value,
                      })
                    }
                    placeholder="******************"
                    className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
                  />
                </div>
                {showPassword.confirmPassword ? (
                  <span
                    className="cursor-pointer "
                    onClick={() =>
                      setShowPassword({
                        ...showPassword,
                        confirmPassword: false,
                      })
                    }
                  >
                    <FaEyeSlash color="#808080" />
                  </span>
                ) : (
                  <span
                    className="cursor-pointer"
                    onClick={() =>
                      setShowPassword({
                        ...showPassword,
                        confirmPassword: true,
                      })
                    }
                  >
                    <FaEye color="#808080" />
                  </span>
                )}
              </div>
              {showPassword.confirmPassInput &&
                !passwordPattern.test(showPassword.confirmPassInput) && (
                  <span className="text-xs font-normal text-red-500">
                    Password must be the same as above.
                  </span>
                )}
            </div>

            <ButtonV2
              title={"Reset Password"}
              loaderColor="#ffffff"
              loading={loading}
              disabled={
                !showPassword.passInput || !showPassword.confirmPassInput
              }
              btnStyle={
                "bg-globalGold rounded-lg w-full flex items-center justify-center mt-5 h-[45px]"
              }
              textStyle={"text-white text-[16px] text-semibold"}
              handleClick={handleResetPassword}
            />
          </form>
        </motion.div>
      </AuthLayout>
    </>
  );
}

export default ResetPassword;
